<template>
  <v-container fluid class="pa-0">
    <v-layout column v-if="!connectedToOnlineAccounting">
      <v-flex xs12>
        <v-toolbar flat dense color="white" class="darken-1">
          <v-toolbar-title>
            Quick, Easy Invoicing
          </v-toolbar-title>
        </v-toolbar>

        <v-layout column>
          <div class="px-2 pt-2">
            <p>Authorize {{ $t('site-title.brief') }} to connect to your Online accounting to streamline creating and
              sending customer invoices and {{ $t( 'terms.vendor' ) }}.  It's fast and easy.</p>

            <p>{{ $t('site-title.brief') }} Quickbooks Connect or Xero Direct is a marginal monthly fee, but frees up countless hours by
              creating accurate invoices and bills, providing the {{ $t('terms.bill-of-lading') }} automatically created for each
              load, and linking back to the load here on {{ $t('site-title.brief') }} for further reference.</p>

            <p>Click below to get started. You'll be asked to connect {{ $t('site-title.brief') }} right away.</p>
          </div>

          <v-layout row justify-center>
            <v-quickbooks-connect-btn  :company-id="company.id"
                                       :loading="connectButtonLoading"
                                       @connecting="connectButtonLoading = true"
                                       @connected="quickbooksConnected"/>
            <v-xero-direct-connect-btn :company-id="company.id"
                                       :connecting="connectButtonLoading"
                                       @connecting="connectButtonLoading = true"
                                       @connected="xeroConnected" />

          </v-layout>
        </v-layout>
      </v-flex>
    </v-layout>
    <quickbooks-section v-else-if="isQbConnected" :company="company">
    </quickbooks-section>
    <xero-section v-else-if="isXroConnected" :company="company">
    </xero-section>
    <span v-else>Something is connected. But what?</span>
  </v-container>

</template>
<script>

import QuickbooksSection from './QuickbooksSection.vue';
import QuickbooksMixin from '@/mixins/quickbooksMixin';
import VQuickbooksConnectBtn from '../../../components/qb/QuickbooksConnectButton.vue';
import XeroSection from './XeroSection.vue';
import VXeroDirectConnectBtn from '../../../components/xero/XeroDirectConnectButton.vue';
import XeroMixin from '../../../mixins/xeroMixin';
import InvoicingMixin from '../../../mixins/invoicingMixin';

export default {
  name: 'InvoicingSection',
  mixins: [
    QuickbooksMixin,
    XeroMixin,
    InvoicingMixin,
  ],
  components: {
    VXeroDirectConnectBtn,
    XeroSection,
    VQuickbooksConnectBtn,
    QuickbooksSection,
  },
  props: {
    company: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      connectButtonLoading: false,
    };
  },
  computed: {
    connectedToOnlineAccounting() {
      return this.company && this.company.id && (this.isQbConnected || this.isXroConnected);
    },
    isQbConnected() {
      return this.isQuickbooksConnected(this.company);
    },
    isXroConnected() {
      return this.isXeroConnected(this.company);
    },

  },
  methods: {
    async quickbooksConnected() {
      this.connectButtonLoading = false;
    },
    async xeroConnected() {
      this.connectButtonLoading = false;
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/Companies/Sections/InvoicingSection.vue